/**
 * 运行时环境配置（CommonJS，单一来源）
 *  - vue.config.js (CommonJS) 和 src/config.js (ESM) 都从这里读取
 *  - 切换环境只改这里的 `env`，vue.config.js 的 proxy target 会自动跟着走
 *  - 这里的 URL 全部是绝对 URL（dev 模式也用绝对 URL 给 vue.config.js 生成 proxy target），
 *    dev 模式下前端 fetch 用相对路径走 devServer proxy，由 src/config.js 决定
 */

const env = 'single';

const interfaceUrl = {
  // 开发环境
  dev: {
    host: 'http://localhost:1400',
    jmallUrl: 'http://localhost:1400',
    jackyunUrl: 'http://192.168.88.51',
    jackyunWebUrl: 'http://192.168.88.51',
    jkyminiUrl: 'http://192.168.129.19:8083/jkymini'
  },
  // 集成测试环境
  moduleTest: {
    host: 'https://home.es86.com:3123/jmall_420001',
    jmallUrl: 'https://home.es86.com:3123/jmall_420001',
    jackyunUrl: 'https://home.es86.com:3112',
    jackyunWebUrl: 'https://home.es86.com:3112',
    jkyminiUrl: 'https://home.es86.com:3112/jkymini'
  },
  // 系统测试环境
  systemTest: {
    host: 'https://home.es86.com:3123/jmall_450001',
    jmallUrl: 'https://home.es86.com:3123/jmall_450001',
    jackyunUrl: 'https://home.es86.com:3111',
    jackyunWebUrl: 'https://home.es86.com:3111',
    jkyminiUrl: 'https://home.es86.com:3111/jkymini'
  },
  // 补丁包测试环境
  hotfix: {
    host: 'https://home.es86.com:3123/jmall_440001',
    jmallUrl: 'https://home.es86.com:3123/jmall_440001',
    jackyunUrl: 'https://home.es86.com:3111',
    jackyunWebUrl: 'https://home.es86.com:3111',
    jkyminiUrl: 'https://home.es86.com:3111/jkymini'
  },
  // 正式环境
  online: {
    host: 'https://jmall.jackyun.com/jmc',
    jmallUrl: 'https://jmall.jackyun.com/jmc',
    jackyunUrl: 'https://api.jackyun.com',
    jackyunWebUrl: 'https://web.jackyun.com',
    jkyminiUrl: 'https://jmi.jackyun.com/jkymini'
  },
  // 灰度环境（与 online 一致，保留独立 key 方便日后区分）
  single: {
    host: 'https://jmall.jackyun.com/jmall_pc_single',
    jmallUrl: 'https://jmall.jackyun.com/jmall_pc_single',
    jackyunUrl: 'https://api.jackyun.com',
    jackyunWebUrl: 'https://web.jackyun.com',
    jkyminiUrl: 'https://jmi.jackyun.com/jkymini'
  }
};

const currInterface = interfaceUrl[env];

module.exports = {
  env,
  interfaceUrl,
  currInterface
};
